import React, { Fragment } from 'react';
import { Container, Row, Col, Input, Label, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage, faCheck, faTimes, faTrashAlt, faDownload } from '@fortawesome/free-solid-svg-icons';
import CompanyContext from '../../auth/CompanyContext';
import ConfirmButton from '../Modal/ConfirmButton';
import { Prompt } from 'react-router-dom';
// import PermissionWrapper from '../../auth/PermissionWrapper';
class Files extends React.Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);

        this.blankFile = {
            file: null,
            description: '',
            uuid: '',
            fileId: 0
        }

        this.state = {
            newFile: JSON.parse(JSON.stringify(this.blankFile)),
            editFile: JSON.parse(JSON.stringify(this.blankFile)),
            editFileId: 0,
            randomKey: new Date().getTime(),
            uploading: false,
            files: [],
            unsavedChanges: false
        };

    }

    componentDidMount = () => {
        this.getFiles();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    humanFileSize = (bytes, dp = 1) => {
        const thresh = 1000;

        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }

        const units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        let u = -1;
        const r = 10 ** dp;

        do {
            bytes /= thresh;
            ++u;
        } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

        return bytes.toFixed(dp) + ' ' + units[u];
    }

    onDownload = (href, filename, e) => {
        e.stopPropagation();
        fetch(href + filename + "?" + new Date().getTime(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Database': this.context.company
            }
        })
            .then(results => results.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', decodeURIComponent(filename));
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
            .catch(() => {
                // this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }


    formatDate = (d) => {
        if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
    }

    getFiles = () => {
        fetch('/api/files/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (this.isUnmounted) return;
                if (results.success) {
                    this.setState({
                        files: results.data.filter(file => file.type === 'attachment')
                    }, () => {
                        if (this.props.callback) {
                            this.props.callback(results.data.filter(file => file.type === 'attachment'))
                        }
                    });
                } else {
                }
            })
            .catch(() => {
            })
    }

    handleUpload = (e, edit) => {
        let f = e.target.files[0];
        let reader = new FileReader();
        if (typeof (f) !== 'object') return;
        try {
            reader.readAsDataURL(f);
            reader.onload = () => {
                let file = {
                    name: f.name,
                    type: f.type,
                    size: f.size,
                    base64: reader.result,
                };
                const stateVar = (edit) ? 'editFile' : 'newFile';
                this.setState((prevState) => {
                    const sel = { ...prevState };
                    sel[stateVar].file = file;
                    sel.unsavedChanges = false;
                    return sel;
                })
            }
        } catch (e) {
            // this.props.addToast('An error has occurred.', 5, 'danger');
        }
    }

    onChange = (e, edit) => {
        e.persist();
        const stateVar = (edit) ? 'editFile' : 'newFile';
        this.setState(prevState => {
            const sel = { ...prevState };
            switch (e.target.name) {
                default:
                    sel[stateVar][e.target.name] = e.target.value;
            }
            sel.unsavedChanges = true;
            return sel
        });
    }

    handleAdd = () => {
        this.setState({
            uploading: true
        }, () => {
            const json_request = JSON.stringify({
                reportId: null,
                auth0: this.props.user,
                type: 'attachment',
                filename: this.state.newFile.file.name,
                filesize: this.state.newFile.file.size,
                filetype: this.state.newFile.file.type,
                data: this.state.newFile.file.base64,
                meta: JSON.stringify({
                    description: this.state.newFile.description,
                })
            });
            fetch('/api/files/', {
                method: 'POST',
                body: json_request,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                }
            }).then(results => results.json())
                .then(results => {
                    results.success ?
                        this.setState({
                            uploading: false,
                            unsavedChanges: true
                        }, () => {
                            this.getFiles();
                            // this.props.addToast('File uploaded successfully.', 5, 'success')
                        })
                        :
                        this.setState({
                            uploading: false,
                        }
                            // , () => this.props.addToast('Unable to upload file.', 5, 'danger')
                        )
                })
                .catch(() => {
                    // this.props.addToast('An error has occurred.', 5, 'danger');
                })
        })
    };

    onEdit = (id) => {
        const file = [...this.state.files].filter(item => item.fileId === id)[0];
        const fileMeta = file.meta != null && file.meta !== '' ? JSON.parse(file.meta) : { description: '' }
        this.setState({
            editFile: {
                fileId: id,
                uuid: file.uuid,
                file: {
                    name: file.filename
                },
                description: fileMeta.description,
            },
            editFileId: id,
            randomKey: new Date().getTime(),
            unsavedChanges: false
        })
    }

    onDelete = (id) => {
        fetch('/api/files/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getFiles();
                    this.setState({
                        unsavedChanges: false
                    })
                    // this.props.addToast('File deleted successfully.', 5, 'success')
                } else {
                    // this.props.addToast('Unable to delete file.', 5, 'danger')
                }
            })
            .catch(() => {
                // this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleEdit = () => {
        if (this.state.editFile.file.base64 != null) {
            // delete old
            fetch('/api/files/' + this.state.editFile.uuid, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                }
            })
                .then(results => results.json())
                .then(results => {
                    if (results.success) {
                        // add new
                        const json_request = JSON.stringify({
                            reportId: null,
                            auth0: this.props.user,
                            type: 'attachment',
                            filename: this.state.editFile.file.name,
                            filesize: this.state.editFile.file.size,
                            filetype: this.state.editFile.file.type,
                            data: this.state.editFile.file.base64,
                            meta: JSON.stringify({
                                description: this.state.editFile.description,
                            })
                        });
                        fetch('/api/files/', {
                            method: 'POST',
                            body: json_request,
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + this.props.clientToken,
                                'X-Database': this.context.company
                            }
                        }).then(results => results.json())
                            .then(results => {
                                results.success ?
                                    this.setState({
                                        uploading: false,
                                        unsavedChanges: false
                                    }, () => {
                                        this.getFiles();
                                        // this.props.addToast('File replaced successfully.', 5, 'success')
                                    })
                                    :
                                    this.setState({
                                        uploading: false,
                                    }
                                        // , () => this.props.addToast('Unable to replace file.', 5, 'danger')
                                    )
                            })
                            .catch(() => {
                                // this.props.addToast('An error has occurred.', 5, 'danger');
                            })
                    } else {
                        // this.props.addToast('Unable to replace file.', 5, 'danger')
                    }
                })
                .catch(() => {
                    // this.props.addToast('An error has occurred.', 5, 'danger');
                })
        } else {
            // edit current
            const json_request = JSON.stringify({
                meta: JSON.stringify({
                    description: this.state.editFile.description,
                })
            });
            fetch('/api/files/' + this.state.editFile.uuid, {
                method: 'PUT',
                body: json_request,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                }
            }).then(results => results.json())
                .then(results => {
                    if (results.success) {
                        this.setState({
                            editFile: JSON.parse(JSON.stringify(this.blankFile)),
                            editFileId: 0,
                            unsavedChanges: false
                        }, () => {
                            this.getFiles();
                            // this.props.addToast('File updated successfully.', 5, 'success')
                        })
                    }
                    // this.props.addToast('Unable to update file.', 5, 'danger');
                })
                .catch(() => {
                    // this.props.addToast('An error has occurred.', 5, 'danger');
                })
        }


    }

    handleReset = () => {
        this.setState({
            newFile: JSON.parse(JSON.stringify(this.blankFile)),
            randomKey: new Date().getTime(),
            unsavedChanges: false
        })
    }

    handleCancel = () => {
        this.setState({
            editFile: JSON.parse(JSON.stringify(this.blankFile)),
            editFileId: 0,
            randomKey: new Date().getTime(),
            unsavedChanges: false
        })
    }

    standardRow = (file) => {
        let meta = (file.meta != null) ? JSON.parse(file.meta) : null;
        return (
            <Row className="adminRow pointer workflowRow" onClick={() => this.onEdit(file.fileId)}>
                <Col md={4} className="text-left">
                    <Button className='p-0 m-0 mb-1' color="link" onClick={(e) => this.onDownload("/uploads/" + file.uuid + '/', file.filename, e)}><FontAwesomeIcon icon={faDownload} /> {decodeURIComponent(file.filename)}</Button>
                    <span className='ml-2'>({this.humanFileSize(file.filesize)})</span>
                </Col>
                <Col md={4}>
                    {meta != null && meta.description != null ? meta.description : ''}
                </Col>
                <Col md={2} className="text-left">
                    {this.formatDate(file.timestamp)}
                </Col>
                <Col md={2} className="text-left">
                    {file.firstName} {file.lastName}
                </Col>
            </Row>
        )
    }

    editRow = (file) => {
        return (<>
            <Row key={"edit" + file.fileId} className="adminRow activeTab align-items-bottom py-4 text-left">
                <Col md={8}>
                    <Row>
                        <Col>
                            <Label className="btn btn-secondary mb-2">
                                <FontAwesomeIcon icon={faImage} className="mr-1" />
                                Replace File
                                <Input
                                    className="fileButton"
                                    type="file"
                                    key={this.state.randomKey}
                                    name={"file_"}
                                    id="file"
                                    accept='.jpg,.png,.gif,.docx,.doc,.xls,.xlsx,.pdf,.csv'
                                    onChange={e => this.handleUpload(e, true)}
                                />
                            </Label>
                        </Col>
                        <Col className='pt-3'>
                            {this.state.editFile.file != null && this.state.editFile.file.name !== '' && <span className='ml-2 mb-2 font-weight-bold'>{this.state.editFile.file.name}</span>}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Input
                                className='mt-2'
                                type="textarea"
                                rows={3}
                                name="description"
                                placeholder='Short Description'
                                value={this.state.editFile.description}
                                onChange={e => this.onChange(e, true)} >
                            </Input>
                        </Col>
                    </Row>
                </Col>
                <Col md={4} className="text-right">
                    {/* <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Files"> */}
                    <Button className="mx-1" color="success" onClick={this.handleEdit} title="Edit File">
                        <FontAwesomeIcon icon={faCheck} />
                    </Button>
                    {/* </PermissionWrapper> */}
                    {/* <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Files"> */}
                    <ConfirmButton className="mx-1" color="danger" onClick={() => this.onDelete(this.state.editFile.uuid)}>
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </ConfirmButton>
                    {/* </PermissionWrapper> */}
                    <Button className="mx-1" color="secondary" onClick={this.handleCancel} title="Cancel">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </Col>
            </Row>
        </>
        )
    }

    addRow = () => {
        return (
            <>
                <Row className="py-4 text-left align-items-bottom ">
                    <Col md={8}>
                        <Row>
                            <Col>
                                <Label className="btn btn-secondary mb-2">
                                    <FontAwesomeIcon icon={faImage} className="mr-1" />
                                    Upload File
                                    <Input
                                        className="fileButton"
                                        type="file"
                                        key={this.state.randomKey}
                                        name={"file_"}
                                        id="file"
                                        accept='.jpg,.png,.gif,.docx,.doc,.xls,.xlsx,.pdf,.csv'
                                        onChange={e => this.handleUpload(e)}
                                    />
                                </Label>
                            </Col>
                            <Col className='pt-3'>
                                {this.state.newFile.file != null && this.state.newFile.file.name !== '' && <span className='ml-2 mb-2 font-weight-bold'>{this.state.newFile.file.name}</span>}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Input
                                    className='mt-2'
                                    type="textarea"
                                    rows={3}
                                    name="description"
                                    placeholder='Short Description'
                                    value={this.state.newFile.description}
                                    onChange={e => this.onChange(e)} >
                                </Input>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={4} className="text-right">
                        {this.state.newFile.file != null && <Button
                            className='mr-2'
                            color="secondary"
                            onClick={this.handleReset}
                        >Reset</Button>}
                        <Button
                            disabled={this.state.newFile.file == null}
                            color="primary"
                            onClick={this.handleAdd}
                        >Add File</Button>
                    </Col>

                </Row>
            </>
        )
    }

    render() {
        return (
            <Container className="text-left" fluid>
                <Prompt
                    when={this.state.unsavedChanges}
                    message="You have unsaved changes, are you sure you want to leave?"
                />
                {this.state.files.length > 0 ? <Row className="adminRow pointer workflowRow font-weight-bold">
                    <Col md={4} className="text-left">
                        File
                    </Col>
                    <Col md={4}>
                        Short Description
                    </Col>
                    <Col md={2} className="text-left">
                        Uploaded
                    </Col>
                    <Col md={2} className="text-left">
                        Author
                    </Col>
                </Row> : <Row><Col className="font-weight-bold">No files available</Col></Row>}
                {this.state.files.map(file => (
                    <Fragment key={file.fileId}>{this.state.editFileId === file.fileId ? this.editRow(file) : this.standardRow(file)}</Fragment>
                ))}
                {/* <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Files"> */}
                <Row>
                    <Col>
                        {this.addRow()}
                    </Col>
                </Row>
                {/* </PermissionWrapper> */}
            </Container>
        );
    }
}

export default Files;